import { config } from '@react-spring/web'

export const transitionValues = {
  config: config.default,
  from: { opacity: 0 },
  enter: { opacity: 1 },
  leave: { opacity: 0 },
}
